import React, { Fragment } from 'react';
import { CheckCircle, Slash } from 'react-feather';
import { ListItemText } from '@material-ui/core';

import { useStyles } from './PublishableStatusComponent.style';

interface IProps {
  status: boolean;
  text: string;
}

export const PublishableStatusComponent: React.FC<IProps> = ({ status, text }) => {
  const classes = useStyles();

  return (
    <ListItemText
      primary={text}
      secondary={
        <Fragment>
          {status && <CheckCircle className={classes.check} />}
          {!status && <Slash className={classes.wrong} />}
        </Fragment>
      }
    />
  );
};
